export function stringJoin(errorMessages: string[] | undefined): string | undefined {
	if (errorMessages === undefined) return undefined;
	else return errorMessages.join(', ');
}